import TableQuery from 'owa-mail-list-store/lib/store/schema/TableQuery';
import { ActionSource } from 'owa-analytics-actions';
import { NotificationSubscription } from 'owa-notification';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import { action } from 'satcheljs';

export const addMarkAsReadDiagnostics = action(
    'addMarkAsReadDiagnostics',
    (
        tableQuery: TableQuery,
        isActingOnAllItemsInTable: boolean,
        isReadValueToSet: boolean,
        actionSource: ActionSource,
        itemsToUpdate?: string[]
    ) => ({
        tableQuery,
        isActingOnAllItemsInTable,
        isReadValueToSet,
        actionSource,
        itemsToUpdate,
    })
);

export const addUnreadCountNotificationDiagnostics = action(
    'addUnreadCountNotificationDiagnostics',
    (groupId: string, notification: NotificationPayloadBase) => ({
        groupId,
        notification,
    })
);

export const addUnreadCountSubscriptionDiagnostics = action(
    'addUnreadCountSubscriptionDiagnostics',
    (groupId: string, subscription: NotificationSubscription, isUnsubscribe: boolean) => ({
        groupId,
        subscription,
        isUnsubscribe,
    })
);
